import { IppicaBreakingNewsCard } from 'components/ippicaBreakingNewsCard';
import { Skeleton } from 'components/skeleton';
import { Wrapper } from 'components/wrapper';
import { useLazyGetIppicaNewsQuery } from 'features/api/ippicaApiSlice';
import { useHideNavigationCarousel } from 'hooks';
import { useEffect, useRef } from 'react';
import { FreeMode, Mousewheel, Navigation } from 'swiper/modules';
import { Swiper, SwiperSlide } from 'swiper/react';
import { breakpoint, isServerSide } from 'utility/constant';
import styles from './IppicaCarousel.module.scss';
import React from 'react';
import { isTruthy } from 'utility/functions';

export type IppicaCarouselProps = {
  label: string;
};

export const IppicaCarousel = ({ label }: IppicaCarouselProps) => {
  const swiperRef = useRef<any>(null);

  const [trigger, { data, isLoading }] = useLazyGetIppicaNewsQuery();
  const { isScrollable, swiperSlideRef } = useHideNavigationCarousel({ className: 'disabled', items: data });

  useEffect(() => {
    if (isServerSide) return;
    trigger();
  }, []);

  if (isServerSide || isLoading) {
    return <Skeleton />;
  }

  if (!isTruthy(data?.length)) {
    return <React.Fragment key={`IppicaCarousel-${label}`} />;
  }

  return (
    <Wrapper noPaddingRight noPaddingLeft bgColorTransparent className="backgroundElement">
      {label && <h2 className={styles.title}> {label} </h2>}
      <div className={styles.container}>
        <Swiper
          onInit={(core) => (swiperSlideRef.current = core.el)}
          spaceBetween={16}
          grabCursor
          slidesPerView={'auto'}
          slidesOffsetBefore={20}
          slidesOffsetAfter={20}
          modules={[Navigation, FreeMode, Mousewheel]}
          updateOnWindowResize
          watchOverflow
          freeMode={{
            enabled: true,
            minimumVelocity: 0.2,
          }}
          mousewheel={{ forceToAxis: true }}
          navigation={isScrollable ? true : false}
          onSwiper={(swiper) => {
            swiperRef.current = swiper;
          }}
          breakpoints={{
            [breakpoint.sm]: {
              slidesOffsetBefore: 32,
              slidesOffsetAfter: 32,
            },
            [breakpoint.lg]: {
              grabCursor: false,
              spaceBetween: 24,
              slidesOffsetBefore: 40,
              slidesOffsetAfter: 40,
              simulateTouch: false,
              allowTouchMove: false,
            },
          }}
        >
          {data?.map((item) => {
            return (
              <SwiperSlide key={item.id}>
                <IppicaBreakingNewsCard item={item} />
              </SwiperSlide>
            );
          })}
        </Swiper>
      </div>
    </Wrapper>
  );
};
